/* eslint-disable */

import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import ModelTag from "../model-tag/model-tag";

const ModelComponentIncident = ({
  incidentId = "incident__123234",
  createdAt = "2021-01-01",
  title = "Fake Title Incident",
  declaredById = "staff_member__1234",
  declaredByName = "John Doe",
}) => {
  return (
    <div
      className={`flex flex-col gap-4  p-4 rounded-lg border-l-2  w-full 

    dark:bg-color-dark-background-secondary bg-color-background-secondary
    dark:border-color-dark-model-incident border-color-model-incident
    `}
    >
      <ModelTag modelId={incidentId} />
      <div>
        <RaindropInput
          label={"Title"}
          value={title}
          onChange={() => {}}
          icon={null}
          isEditing={false}
          isShowLabel={true}
        />
        <RaindropInput
          label={"Created At"}
          value={createdAt}
          onChange={() => {}}
          icon={null}
          isEditing={false}
          isShowLabel={true}
        />

        <div className="flex flex-col gap-2">
          <div className="text-xs text-color-dark-text-tertiary">
            Declared by
          </div>
          <div className="flex flex-row items-center gap-2">
            <ModelTag modelId={declaredById} isSmall={true} />
            {declaredByName}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelComponentIncident;
